// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-field {
    width: 250px;
}

.row-heading {
    margin-top: 7px;
}

.error-message-general {
    color: #ba2121;
  }`, "",{"version":3,"sources":["webpack://./src/asset/style/settings/manageusers/change_password.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;EAChB","sourcesContent":[".input-field {\n    width: 250px;\n}\n\n.row-heading {\n    margin-top: 7px;\n}\n\n.error-message-general {\n    color: #ba2121;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
